import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.splice";
import _classCallCheck from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module undo/undocommand
 */
import BaseCommand from './basecommand';
/**
 * The undo command stores {@link module:engine/model/batch~Batch batches} applied to the
 * {@link module:engine/model/document~Document document} and is able to undo a batch by reversing it and transforming by
 * batches from {@link module:engine/model/document~Document#history history} that happened after the reversed batch.
 *
 * The undo command also takes care of restoring the {@link module:engine/model/document~Document#selection document selection}.
 *
 * @extends module:undo/basecommand~BaseCommand
 */

var UndoCommand = /*#__PURE__*/function (_BaseCommand) {
  _inherits(UndoCommand, _BaseCommand);

  var _super = _createSuper(UndoCommand);

  function UndoCommand() {
    _classCallCheck(this, UndoCommand);

    return _super.apply(this, arguments);
  }

  _createClass(UndoCommand, [{
    key: "execute",

    /**
     * Executes the command. This method reverts a {@link module:engine/model/batch~Batch batch} added to the command's stack, transforms
     * and applies the reverted version on the {@link module:engine/model/document~Document document} and removes the batch from the stack.
     * Then, it restores the {@link module:engine/model/document~Document#selection document selection}.
     *
     * @fires execute
     * @fires revert
     * @param {module:engine/model/batch~Batch} [batch] A batch that should be undone. If not set, the last added batch will be undone.
     */
    value: function execute() {
      var _this = this;

      var batch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // If batch is not given, set `batchIndex` to the last index in command stack.
      var batchIndex = batch ? this._stack.findIndex(function (a) {
        return a.batch == batch;
      }) : this._stack.length - 1;

      var item = this._stack.splice(batchIndex, 1)[0];

      var undoingBatch = this.editor.model.createBatch({
        isUndo: true
      }); // All changes has to be done in one `enqueueChange` callback so other listeners will not
      // step between consecutive operations, or won't do changes to the document before selection is properly restored.

      this.editor.model.enqueueChange(undoingBatch, function () {
        _this._undo(item.batch, undoingBatch);

        var operations = _this.editor.model.document.history.getOperations(item.batch.baseVersion);

        _this._restoreSelection(item.selection.ranges, item.selection.isBackward, operations);

        _this.fire('revert', item.batch, undoingBatch);
      });
      this.refresh();
    }
  }]);

  return UndoCommand;
}(BaseCommand);
/**
 * Fired when execution of the command reverts some batch.
 *
 * @event revert
 */


export { UndoCommand as default };